<template>
  <div>
    <!-- CLEAR ALL FILTERS -->
    <ais-clear-refinements
      :excluded-attributes="['pickup.ts', 'delivery.ts']"
    >
      <a
        class="clear-filter-btn"
        slot-scope="{ canRefine, refine }"
        @click.prevent="refine(); cleareAllDates()"
        v-if="canRefine || Object.keys(generalApp.algoliaDateFilters).length > 0"
      >
        {{$t('general.clear_all_filters')}}
        <v-icon class="pl-1" small>clear</v-icon>
      </a>
      <span v-else></span>
    </ais-clear-refinements>

    <!-- LIST OF ALL SELECTED FILTERS -->

    <!-- Date filters -->
    <!-- <span
      v-for="dateFilter in dateFiltersBadges"
      :key="'dateFilter-' + dateFilter.index"
    >
      <b>{{ dateFilter.title }}: </b>
      <a
        class="clear-filter-btn"
        @click.prevent="clearDate(dateFilter.index)"
      >
        {{ dateFilter.date }}
        <v-icon class="pl-1" small>clear</v-icon>
      </a>
    </span> -->

    <!-- Other filters -->
    <span v-show="removeRangeDateFilters(item.label)" v-for="(item, index) in algoliaSelectedFilters" :key="index+'-currentfilter'">
      <div>
        <b>{{ filtersAtributeNameMap[item.label] ? filtersAtributeNameMap[item.label].value : item.label }}: </b>
        <a
          class="clear-filter-btn"
          v-for="refinement in item.refinements"
          :key="[
            refinement.attribute,
            refinement.type,
            refinement.value,
            refinement.operator
          ].join(':')"
          @click.prevent="item.refine(refinement)"
        >
          <span v-if="filtersAtributeNameMap[item.label] && filtersAtributeNameMap[item.label].i18nPreffix">
            {{ $t(filtersAtributeNameMap[item.label].i18nPreffix + refinement.label) }}
          </span>
          <span v-else>
            {{ refinement.label }}
          </span>
          <v-icon class="pl-1" small>clear</v-icon>
        </a>
      </div>
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors/'
import { generalHelpers } from '@/_helpers'

export default {
  name: 'AlgoliaCurrentFilters',
  mixins: [
    createWidgetMixin({ connector: connectCurrentRefinements })
  ],
  data () {
    return {
      algoliaSelectedFilters: [],
      selectedFilters: [],
      excludedFilterAtributes: [
        "pickupLocal.from", "deliveryLocal.from"
      ]
    }
  },
  computed: {
    ...mapState(['generalApp']),
    algoliaStateItems () {
      let results = []

      if (this.state !== null) {
        results = this.state.items
      }

      return results
    },
    dateFiltersBadges () {
      let dateFilters = []

      for (let i = 0; i < Object.keys(this.generalApp.algoliaDateFilters).length; i++) {
        const dateField = this.generalApp.algoliaDateFilters[Object.keys(this.generalApp.algoliaDateFilters)[i]]
        const splitted = dateField.split(':')
        const timeStamps = splitted[1].split(' ')
        // if (timeStamps[0] < 10000000000) { // if it is in seconds and not miliseconds
        //   timeStamps[0] *= 1000
        // }
        // if (timeStamps[2] < 10000000000) { // if it is in seconds and not miliseconds
        //   timeStamps[2] *= 1000
        // }
        // const dateFrom = this.$options.filters.unixDateToNumeric(timeStamps[0], this.$i18n.locale)
        // const dateTo = this.$options.filters.unixDateToNumeric(timeStamps[2], this.$i18n.locale)
        // const filter = {
        //   index: Object.keys(this.generalApp.algoliaDateFilters)[i],
        //   title: (this.filtersAtributeNameMap[splitted[0]] ? this.filtersAtributeNameMap[splitted[0]].value : splitted[0]),
        //   date: dateFrom === dateTo ? dateFrom : (dateFrom + ' - ' + dateTo)
        // }
        let start = timeStamps[0]
        let end = timeStamps[2]
        let diff = generalHelpers.calculateTimeDifferencesJustNumber(start, end)
        const dateFrom = this.$options.filters.dateToReadableTz(start)
        const dateTo = this.$options.filters.dateToReadableTz(end)
        if (diff <= 24) {
          const filter = {
            index: Object.keys(this.generalApp.algoliaDateFilters)[i],
            title: (this.filtersAtributeNameMap[splitted[0]] ? this.filtersAtributeNameMap[splitted[0]].value : splitted[0]),
            date: dateFrom
          }
          dateFilters.push(filter)
        } else {
          const filter = {
            index: Object.keys(this.generalApp.algoliaDateFilters)[i],
            title: (this.filtersAtributeNameMap[splitted[0]] ? this.filtersAtributeNameMap[splitted[0]].value : splitted[0]),
            date: (dateFrom + ' - ' + dateTo)
          }
          dateFilters.push(filter)
        }
      }
      return dateFilters
    },
    filtersAtributeNameMap () {
      return {
        'type': { value: this.$i18n.t('shipments.type') },
        'status': { value: this.$i18n.t('orders.status'), i18nPreffix: 'orders.' },
        'labels': { value: this.$i18n.t('shipments.labels') },
        'origin.company': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller') },
        'destination.company': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer') },
        'origin.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin') },
        'destination.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination') },
        'vehicle.owner': { value: this.$i18n.t('shipments.vehicle_owner') },
        'driver.name': { value: this.$i18n.t('shipments.driver') },

        'buyer.order_ref': { value: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.buyer') },
        'seller.order_ref': { value: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.seller') },
        'buyer.name': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer') },
        'seller.name': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller') },
        'pickup.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin') },
        'delivery.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination') },
        'weight': { value: this.$i18n.t('orders.weight') },
        'volume': { value: this.$i18n.t('orders.volume') },
        'origin.departure': { value: this.$i18n.t('shipments.departure') },
        'destination.arrival': { value: this.$i18n.t('shipments.arrival') },
        'pickup.ts': { value: this.$i18n.t('shipments.departure') },
        'delivery.ts': { value: this.$i18n.t('shipments.arrival') },
        'originAddress.dates_fromTS': { value: this.$i18n.t('shipments.departure') },
        'destinationAddress.dates_fromTS': { value: this.$i18n.t('shipments.arrival') },

        'transportRequestRefNum': { value: this.$i18n.t('transport_request.transport_request_ref_num_short') },
        'originAddress.reference_number': { value: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.buyer') },
        'destinationAddress.reference_number': { value: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.seller') },
        'originAddress.company': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer') },
        'destinationAddress.company': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller') },
        'originAddress.locShort': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin') },
        'destinationAddress.locShort': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination') },
        'transportRequestStatus': { value: this.$i18n.t('orders.status'), i18nPreffix: 'transport_request.' },
        'origin.orgName': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller') },
        'destination.orgName': { value: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer') },
        // 'origin.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin') },
        // 'destination.address': { value: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination') },
        // 'status': { value: this.$i18n.t('shipments.status'), i18nPreffix: 'drops.' },
        'consolidation': { value: this.$i18n.t('drops.consolidation'), i18nPreffix: 'drops.' }
      }
    }
  },
  methods: {
    ...mapActions({
      setDateFilter: 'setDateFilter',
      clearDateFilter: 'clearDateFilter'
    }),
    clearDate (index) {
      this.setDateFilter({ filter: '', index: index })
    },
    cleareAllDates () {
      this.$emit('clear-all')
      this.clearDateFilter()
    },
    removeRangeDateFilters (label) {
      if (label === 'arrival' || label === 'departure', label === 'departureUTC') {
        return false
      }
      return true
    }
  },
  watch: {
    algoliaStateItems (filters, oldFilters) {
      if (!generalHelpers.isEqual(filters, oldFilters)) {
        let selectedFilters = []
        filters.forEach(el => {
          selectedFilters.push(el)
        })
        this.algoliaSelectedFilters = selectedFilters.filter(
          value => {
            return !(this.excludedFilterAtributes.includes(value.label))
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .algolia-current-filters {
    padding-bottom: 5px;
    margin-bottom: 15px;
    border-bottom: 1px solid lightgray;
  }
  .clear-filter-btn {
    margin: 2px;
    padding: 1px 3px;
    border-radius: 4px;
    background-color: #EEEEEE;
    text-decoration: none;
    display: inline-block;

    &:hover {
      background-color: #d6d6d6;
    }
  }
  ::v-deep ul.ais-CurrentRefinements-list {
    padding-left: 0;
    display: inline-block;
  }
  ::v-deep li.ais-CurrentRefinements-item {
    display: inline-block;
    list-style: none;
    padding-right: 5px;
  }
  .ais-CurrentRefinements {
    width: auto;
    display: inline-block;
  }
</style>
